document.addEventListener('click', function(e){
  const a=e.target.closest('a[href^="#"]');
  if(!a) return;
  const href=a.getAttribute('href');
  if(!href || href === '#') return;
  const target=document.querySelector(href);
  if(target){e.preventDefault();target.scrollIntoView({behavior:'smooth',block:'start'});}
});

document.addEventListener('change', function(e){
  const select=e.target.closest('[data-gp-variant-select]');
  if(!select) return;
  const form=select.closest('form');
  if(!form) return;
  const option=select.options[select.selectedIndex];
  const idInput=form.querySelector('input[name="id"]');
  const priceEl=form.closest('.gp-product-panel')?.querySelector('[data-gp-price]');
  const compareEl=form.closest('.gp-product-panel')?.querySelector('[data-gp-compare]');
  const submit=form.querySelector('button[type="submit"]');
  if(idInput) idInput.value=option.value;
  if(priceEl && option.dataset.price) priceEl.textContent=option.dataset.price;
  if(compareEl){
    compareEl.textContent=option.dataset.compare || '';
    compareEl.style.display=option.dataset.compare ? 'inline' : 'none';
  }
  if(submit){
    const available=option.dataset.available === 'true';
    submit.disabled=!available;
    submit.textContent=available ? (submit.dataset.availableText || 'Add to cart') : (submit.dataset.soldoutText || 'Sold out');
  }
});
